import { usePreferredUnits } from '../../../services/entities/hooks/settings/usePreferredUnits';
import { defaultUserSettings } from '../../../services/entities/hooks/settings/useSettings';

/**
 * Returns the preferred units or the default units if no preferred units are set.
 * @returns The preferred units or the default units.
 */
export const useUnits = () => {
  const { preferredUnits } = usePreferredUnits();
  const units = preferredUnits ?? defaultUserSettings.units;
  return units;
};
